import { css, html } from 'react-strict-dom';
import { Api } from 'src/api';
import { color } from 'src/constants/color.css';

type Props = {
  company: Api.Company.BaseView | null;
  /** Used as the alt text, since the logo stands in for the work's client. */
  title: string;
};

/**
 * The small client tile shown beside a timer entry.  Falls back to a blank tile
 * so rows stay aligned when the work isn't tied to any one client.
 */
export default function TimerCompanyLogo({ company, title }: Props) {
  if (!company) return <html.div style={styles.placeholder} />;

  return (
    <html.img
      style={styles.logo}
      src={`/img/companies/${company.slug}.png`}
      alt={`${company.name} — ${title}`}
    />
  );
}

const styles = css.create({
  placeholder: {
    flexShrink: 0,
    width: 20,
    height: 20,
    borderRadius: 4,
    backgroundColor: color.neutral10,
  },
  logo: {
    flexShrink: 0,
    width: 20,
    height: 20,
    borderRadius: 4,
    objectFit: 'cover',
  },
});
